module.exports = __webpack_public_path__ + "static/media/1.497a5c23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/1.jpg
// module id = 534
// module chunks = 0